:host{display:block;border-radius:var(--bs-modal-border-radius, .5rem)}:host.modal-confirm-warning{overflow:hidden;border:2px solid var(--bs-warning, #ffc107);box-shadow:0 0 0 1px #7853002e,0 .75rem 2rem #0c23423d}
/*# sourceMappingURL=modal-confirm.component-43XYB3G3.css.map */
